import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "submit-values" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]

import { computed } from 'vue';
import { useStore } from 'vuex';
import type { PaymentValues } from '@src/view_models/Payment';
import type { Address } from '@src/view_models/Address';
import { addressTypeName } from '@src/view_models/AddressTypeModel';
import type { BankAccountValues } from '@src/view_models/BankAccount';
import type { TrackingData } from '@src/view_models/TrackingData';
import type { CampaignValues } from '@src/view_models/CampaignValues';
import { clearStreetAndBuildingNumberSeparator } from '@src/util/street_and_building_number_tools';

// Define component props
interface Props {
	trackingData?: TrackingData;
	campaignValues?: CampaignValues;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SubmitValues',
  props: {
    trackingData: {},
    campaignValues: {}
  },
  setup(__props: any) {



const store = useStore();

const payment = computed( () => store.state.payment.values as PaymentValues );
const address = computed( () => store.state.address.values as Address );
const addressType = computed( () => addressTypeName( store.state.address.addressType ) );
const bankdata = computed( () => store.state.bankdata.values as BankAccountValues );

const sendPostalAddress = computed( (): boolean => {
	return addressType.value !== 'anonym' && addressType.value !== 'email';
} );

const sendNameAndEmail = computed( (): boolean => {
	return addressType.value !== 'anonym';
} );

const newsletter = computed( (): string => {
	return store.getters[ 'address/willGetNewsletter' ] ? '1' : '0';
} );

const receipt = computed( (): string => {
	return store.getters[ 'address/willGetReceipt' ] ? '1' : '0';
} );

const street = computed( (): string => {
	return clearStreetAndBuildingNumberSeparator( store.state.address.values.street );
} );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("input", {
      type: "hidden",
      name: "paymentType",
      value: payment.value.type
    }, null, 8, _hoisted_2),
    _createElementVNode("input", {
      type: "hidden",
      name: "interval",
      value: payment.value.interval
    }, null, 8, _hoisted_3),
    _createElementVNode("input", {
      type: "hidden",
      name: "amount",
      value: payment.value.amount
    }, null, 8, _hoisted_4),
    _createElementVNode("input", {
      type: "hidden",
      name: "iban",
      value: bankdata.value.iban
    }, null, 8, _hoisted_5),
    _createElementVNode("input", {
      type: "hidden",
      name: "bic",
      value: bankdata.value.bic
    }, null, 8, _hoisted_6),
    _createElementVNode("input", {
      type: "hidden",
      name: "addressType",
      value: addressType.value
    }, null, 8, _hoisted_7),
    (sendNameAndEmail.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("input", {
            type: "hidden",
            name: "salutation",
            value: address.value.salutation
          }, null, 8, _hoisted_8),
          _createElementVNode("input", {
            type: "hidden",
            name: "title",
            value: address.value.title
          }, null, 8, _hoisted_9),
          _createElementVNode("input", {
            type: "hidden",
            name: "firstName",
            value: address.value.firstName
          }, null, 8, _hoisted_10),
          _createElementVNode("input", {
            type: "hidden",
            name: "lastName",
            value: address.value.lastName
          }, null, 8, _hoisted_11),
          _createElementVNode("input", {
            type: "hidden",
            name: "email",
            value: address.value.email
          }, null, 8, _hoisted_12)
        ], 64))
      : _createCommentVNode("", true),
    (sendPostalAddress.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("input", {
            type: "hidden",
            name: "street",
            value: street.value
          }, null, 8, _hoisted_13),
          _createElementVNode("input", {
            type: "hidden",
            name: "postcode",
            value: address.value.postcode
          }, null, 8, _hoisted_14),
          _createElementVNode("input", {
            type: "hidden",
            name: "city",
            value: address.value.city
          }, null, 8, _hoisted_15),
          _createElementVNode("input", {
            type: "hidden",
            name: "country",
            value: address.value.country
          }, null, 8, _hoisted_16)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      type: "hidden",
      name: "companyName",
      value: address.value.companyName
    }, null, 8, _hoisted_17),
    _createElementVNode("input", {
      type: "hidden",
      name: "info",
      value: newsletter.value
    }, null, 8, _hoisted_18),
    _createElementVNode("input", {
      type: "hidden",
      name: "donationReceipt",
      value: receipt.value
    }, null, 8, _hoisted_19),
    _createElementVNode("input", {
      type: "hidden",
      name: "impCount",
      value: __props.trackingData.impressionCount
    }, null, 8, _hoisted_20),
    _createElementVNode("input", {
      type: "hidden",
      name: "bImpCount",
      value: __props.trackingData.bannerImpressionCount
    }, null, 8, _hoisted_21),
    _createElementVNode("input", {
      type: "hidden",
      name: "piwik_campaign",
      value: __props.campaignValues.campaign
    }, null, 8, _hoisted_22),
    _createElementVNode("input", {
      type: "hidden",
      name: "piwik_kwd",
      value: __props.campaignValues.keyword
    }, null, 8, _hoisted_23)
  ]))
}
}

})